<template>
  <card card-body-classes="table-full-width" no-footer-line>
    <h5>Arquivos</h5>
    <div class="display-grid-column grid-3 my-2">
      <div
        v-for="file in files"
        :key="file.id"
        class="alert alert-primary mx-3"
      >
        <button
          @click="removeFileAttach(file)"
          type="button"
          aria-hidden="true"
          class="close"
          :disabled="removingFile"
        >
          <i v-if="!removingFile" class="now-ui-icons ui-1_simple-remove"></i>
          <i v-else class="fa fa-spinner fa-spin"></i>
        </button>
        <span @click="openFileUrl(file)" class="link-btn">{{ file.original_name }}</span>
      </div>
    </div>
    <VueFileAgent
      class="mt-3"
      ref="vueFileAgent"
      :theme="'list'"
      :multiple="true"
      :deletable="true"
      :meta="true"
      :accept="'image/*,.pdf'"
      :maxSize="'10MB'"
      :maxFiles="14"
      :helpText="'Envie arquivo'"
      :errorText="{
        type: 'Invalid file type. Only images or zip Allowed',
        size: 'Files should not exceed 10MB in size',
      }"
      @select="filesSelected($event)"
      @beforedelete="onBeforeDelete($event)"
      @delete="fileDeleted($event)"
      v-model="fileRecords"
    ></VueFileAgent>
    <div class="d-flex justify-content-center my-3">
      <span
        v-if="!loading"
        @click="uploadFiles()"
        :disabled="!fileRecordsForUpload.length"
        class="btn btn-primary"
      >
        Carregar {{ fileRecordsForUpload.length }} arquivo(s)
      </span>
      <span v-else :disabled="true" class="btn btn-primary">
        <i class="fa fa-spinner fa-spin"></i> Carregando
      </span>
    </div>
  </card>
</template>
<script>
import FormData from "form-data";
import { TabPane, Tabs } from "src/components";

export default {
  name: "FilesAttach",
  components: {
    TabPane,
    Tabs,
  },
  props: {
    product_id: {
      value: [Number, String],
    },
  },
  data: function () {
    return {
      loading: false,
      removingFile: false,
      fileRecords: [],
      uploadUrl: "https://www.mocky.io/v2/5d4fb20b3000005c111099e3",
      uploadHeaders: { "Content-Type": "multipart/form-data" },
      fileRecordsForUpload: [],
      files: [],
    };
  },
  mounted() {
    this.getProductFiles();
  },
  methods: {
    uploadFiles: function () {
      this.loading = true;
      let formData = new FormData();
      this.fileRecordsForUpload.forEach((fileRecord) => {
        formData.append("file[]", fileRecord.file);
      });

      this.$store
        .dispatch("product/attachFiles", {
          product_id: this.product_id,
          files: formData,
        })
        .then(() => {
          this.getProductFiles();
          this.fileRecordsForUpload = [];
          this.fileRecords = [];
        })
        .catch(() => {}) 
        .finally(() => {
          this.loading = false;
        });
    },
    getProductFiles() {
      this.$store
        .dispatch("product/getFiles", this.product_id)
        .then((files) => {
          this.files = files;
        });
    },
    deleteUploadedFile: function (fileRecord) {
      // Using the default uploader. You may use another uploader instead.
      this.$refs.vueFileAgent.deleteUpload(
        this.uploadUrl,
        this.uploadHeaders,
        fileRecord
      );
    },
    filesSelected: function (fileRecordsNewlySelected) {
      var validFileRecords = fileRecordsNewlySelected.filter(
        (fileRecord) => !fileRecord.error
      );
      this.fileRecordsForUpload =
        this.fileRecordsForUpload.concat(validFileRecords);
    },
    onBeforeDelete: function (fileRecord) {
      var i = this.fileRecordsForUpload.indexOf(fileRecord);
      if (i !== -1) {
        this.fileRecordsForUpload.splice(i, 1);
      } else {
        if (confirm("Are you sure you want to delete?")) {
          this.$refs.vueFileAgent.deleteFileRecord(fileRecord); // will trigger 'delete' event
        }
      }
    },
    fileDeleted: function (fileRecord) {
      var i = this.fileRecordsForUpload.indexOf(fileRecord);
      if (i !== -1) {
        this.fileRecordsForUpload.splice(i, 1);
      } else {
        this.deleteUploadedFile(fileRecord);
      }
    },
    openFileUrl(file) {
      window.open(file.url, "_blank");
    },
    removeFileAttach(file) {
      this.removingFile = true;
      this.$store
        .dispatch("product/removeFile", {
          product_id: this.product_id,
          file_id: file.id,
        })
        .then(() => {
          this.getProductFiles();
        })
        .finally(() => {
          this.removingFile = false;
        });
    },
  },
};
</script>
<style scoped>
.link-btn {
  cursor: pointer;
}
.link-btn:hover {
  text-decoration: underline;
  color: black;
}
</style>
